import { AppConfig } from "../../../shared/app-configs/app-config";
import { TCAppConfig } from "../../../shared/app-configs/tc-app-configs";
import apiService from "../../../shared/service/api-service";

export const dtrackItService = {
    async getOrganicFarmStandards() {
        const queryParams = {
            query_param: TCAppConfig.GET_ORGANIC_FARM_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },

    async getStandradLabelGrade() {
        const queryParams = {
            query_param: TCAppConfig.GET_STANDARD_LABEL_GRADE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },


    async getProductCategory() {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },

    async getProductDetailsCode() {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_DETAIL_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },

    async getCountry() {
        const queryParams = {
            query_param: TCAppConfig.GET_COUNTRY_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },

    async getStateBasedonCountry(country: any) {
        const queryParams = {
            query_param: TCAppConfig.GET_STATE_CODE,
            country: country
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },
    async getRawMaterialCodes(standards?: string[] | string) {
        const queryParams: Record<string, any> = {
            query_param: TCAppConfig.GET_RAW_MATERIAL_CODE
        }
        if (Array.isArray(standards) && standards.length) {
            queryParams.standard = standards.join(",");
        } else if (typeof standards === "string" && standards.trim()) {
            queryParams.standard = standards.trim();
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },
    async getCBLicensingCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_CBLICENSING_CODE
        }
        const response = await apiService.get<any>(`v1/tc/get-dtrackit-ref-code`,queryParams)
        return response;
    },
    async getFacilityProcessCategoryCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_FACILITY_PROCESS_CATEGORY_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.DTRACKIT_BASE_ENDPOINT, queryParams)
        return response;
    },

    async getStandradLabelGradeOnBasisOfSelectedStandard(standard: string[]) {
        const queryParams = {
            standard: [...standard,"NA"],
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_STANDARD, queryParams)
        return response;
    },
}
